export const MODE_POINT = 'point';
export const MODE_POLYGON = 'polygon';
export const MODE_RECTANGLE = 'rectangle';
export const MODE_NONE = 'none';
